// extracted by mini-css-extract-plugin
export default {"container":"CustomRadio_container__JBohf","hiddenInput":"CustomRadio_hiddenInput__xRvOH","customRadio":"CustomRadio_customRadio__pvm4g","checked":"CustomRadio_checked__57vva"};